// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -- Toolbar -- */
.dashboard-toolbar {
  background: #fff;  
  font-size: 13px;
  color: #fff;
  padding: 12px 20px;
  height: auto;
  min-height: 56px;
  flex-wrap: wrap;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.legend {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  color: #000000;
  font-weight: 500;
}

.dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.dot.not-started { background-color: #E2F415; }
.dot.in-progress { background-color: #1CB01E; }
.dot.repeat      { background-color: #E94141; }
.dot.alertt      { background-color: #8c8f93; }

.refreshed {
  color: black;
  margin-left: 12px;
  font-size: 12px;
}

.spacer { flex: 1; }

/* -- Table -- */
.table-container {
  margin: 16px;
  border-radius: 8px;
  overflow-x: auto;
  width: calc(100% - 32px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  background: #fff;
}

/* Fullscreen */
.fullscreen-container {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999 !important;
  background: #fff !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.fullscreen-container .dashboard-toolbar {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.fullscreen-container .table-container {
  flex: 1 !important;
  overflow-y: auto !important;
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  width: 100% !important;
  height: 100% !important;
}

/* -- Project Cell -- */
.project-id {
  color: #000;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 1px;
  line-height: 1.3;
}

.meta {
  font-size: 11px;
  color: #000;
  font-weight: 400;
  line-height: 1.4;
}

.meta strong {
  font-weight: 600;
}

/* -- Legacy Test Span Styles -- */
.testSpan {
  display: inline-block;
  padding: 3px;
  margin: 2px;
  border: 1px solid #DDDDDD;
  border-radius: 3px;
  vertical-align: middle;
}

.testSpan .detailTable {
  border-collapse: collapse;
  margin: 0;
}

.testSpan .testTitle {
  font-size: 10pt;
  text-align: center;
  border-width: 0px;
  font-weight: bold;
  padding: 4px 8px;
}

/* Test Status Colors */
.testNotStarted {
  background-color: #E2F415;
}

.testInProgress {
  background-color: #1CB01E;
}

.testRepeat {
  background-color: #E94141;
}

/* Test Status Colors with Alerts */
.testNotStartedAlert {
  background-color: #E2F415;
  border: blue 2px dashed;
}

.testInProgressAlert {
  background-color: #1CB01E;
  border: blue 2px dashed;
}

.testRepeatAlert {
  background-color: #E94141;
  border: blue 2px dashed;
}

.dashboardAlert {
  border: blue 2px solid;
}

/* -- Responsive -- */
@media (max-width: 600px) {
  .dashboard-toolbar {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 8px 12px;
  }
}

/* -- Column sizing via ::ng-deep to reach inside data-grid child component --
   Pin PROJECT UFID and SLURRY NAME to fixed widths so they don't grow.
   TESTS column gets flex-grow:1 to fill all remaining space. */
:host ::ng-deep .mat-column-projectUfid {
  flex: 0 0 160px !important;
  max-width: 160px !important;
  min-width: 160px !important;
  border-right: 1px solid #dee2e6 !important;
}

:host ::ng-deep .mat-column-slurryName {
  flex: 0 0 130px !important;
  max-width: 130px !important;
  min-width: 130px !important;
  border-right: 1px solid #dee2e6 !important;
}

:host ::ng-deep .mat-column-tests {
  flex: 1 0 300px !important;
  padding-left: 12px !important;
}

/* Align test badges to the left with consistent spacing */
:host ::ng-deep .mat-column-tests .mat-mdc-cell,
:host ::ng-deep .mat-column-tests mat-cell {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 6px 8px !important;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/operations-dashboard/operations-dashboard.component.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;;AAE9C;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,UAAU,OAAO,EAAE;;AAEnB,gBAAgB;AAChB;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,0DAA0D;AAC1D;;EAEE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":["/* -- Toolbar -- */\n.dashboard-toolbar {\n  background: #fff;  \n  font-size: 13px;\n  color: #fff;\n  padding: 12px 20px;\n  height: auto;\n  min-height: 56px;\n  flex-wrap: wrap;\n  gap: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.legend {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  color: #000000;\n  font-weight: 500;\n}\n\n.dot {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.dot.not-started { background-color: #E2F415; }\n.dot.in-progress { background-color: #1CB01E; }\n.dot.repeat      { background-color: #E94141; }\n.dot.alertt      { background-color: #8c8f93; }\n\n.refreshed {\n  color: black;\n  margin-left: 12px;\n  font-size: 12px;\n}\n\n.spacer { flex: 1; }\n\n/* -- Table -- */\n.table-container {\n  margin: 16px;\n  border-radius: 8px;\n  overflow-x: auto;\n  width: calc(100% - 32px);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n  background: #fff;\n}\n\n/* Fullscreen */\n.fullscreen-container {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: 9999 !important;\n  background: #fff !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n}\n\n.fullscreen-container .dashboard-toolbar {\n  flex-shrink: 0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.fullscreen-container .table-container {\n  flex: 1 !important;\n  overflow-y: auto !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* -- Project Cell -- */\n.project-id {\n  color: #000;\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 1px;\n  line-height: 1.3;\n}\n\n.meta {\n  font-size: 11px;\n  color: #000;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.meta strong {\n  font-weight: 600;\n}\n\n/* -- Legacy Test Span Styles -- */\n.testSpan {\n  display: inline-block;\n  padding: 3px;\n  margin: 2px;\n  border: 1px solid #DDDDDD;\n  border-radius: 3px;\n  vertical-align: middle;\n}\n\n.testSpan .detailTable {\n  border-collapse: collapse;\n  margin: 0;\n}\n\n.testSpan .testTitle {\n  font-size: 10pt;\n  text-align: center;\n  border-width: 0px;\n  font-weight: bold;\n  padding: 4px 8px;\n}\n\n/* Test Status Colors */\n.testNotStarted {\n  background-color: #E2F415;\n}\n\n.testInProgress {\n  background-color: #1CB01E;\n}\n\n.testRepeat {\n  background-color: #E94141;\n}\n\n/* Test Status Colors with Alerts */\n.testNotStartedAlert {\n  background-color: #E2F415;\n  border: blue 2px dashed;\n}\n\n.testInProgressAlert {\n  background-color: #1CB01E;\n  border: blue 2px dashed;\n}\n\n.testRepeatAlert {\n  background-color: #E94141;\n  border: blue 2px dashed;\n}\n\n.dashboardAlert {\n  border: blue 2px solid;\n}\n\n/* -- Responsive -- */\n@media (max-width: 600px) {\n  .dashboard-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n    height: auto;\n    padding: 8px 12px;\n  }\n}\n\n/* -- Column sizing via ::ng-deep to reach inside data-grid child component --\n   Pin PROJECT UFID and SLURRY NAME to fixed widths so they don't grow.\n   TESTS column gets flex-grow:1 to fill all remaining space. */\n:host ::ng-deep .mat-column-projectUfid {\n  flex: 0 0 160px !important;\n  max-width: 160px !important;\n  min-width: 160px !important;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n:host ::ng-deep .mat-column-slurryName {\n  flex: 0 0 130px !important;\n  max-width: 130px !important;\n  min-width: 130px !important;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n:host ::ng-deep .mat-column-tests {\n  flex: 1 0 300px !important;\n  padding-left: 12px !important;\n}\n\n/* Align test badges to the left with consistent spacing */\n:host ::ng-deep .mat-column-tests .mat-mdc-cell,\n:host ::ng-deep .mat-column-tests mat-cell {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 6px 8px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
